import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import API from "src/services/api";
import InputForm from "../forms/InputForm";

const TagModal = ({ taskgroupId, onSubmitModal }) => {
  const [show, setShow] = useState(false);

  // Validierungsschema
  const schema = Joi.object({
    name: Joi.string().required(),
    icon: Joi.string().allow(""),
    gui_order: Joi.number().required(),
  });

  const {
    reset,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(schema),
  });

  const handleClose = () => setShow(false);
  const handleShow = () => {
    reset({ name: "", icon: "", gui_order: 0 });
    setShow(true);
  };

  const onSubmit = async (formData) => {
    let result = await API.createTag(taskgroupId, formData);

    if (result.status === true && result.data.id) {
      console.log("ok");
      onSubmitModal();
      handleClose();
    } else {
      console.log("error");
      // Error
    }
  };
  console.log(errors);
  return (
    <React.Fragment>
      <Button
        variant="success"
        onClick={() => handleShow()}
        className="add-margin"
      >
        Tag erstellen
      </Button>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Tag erstellen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputForm
            id="name"
            label="Name"
            register={register}
            errors={errors}
          />
          <InputForm
            id="icon"
            label="Icon"
            register={register}
            errors={errors}
          />
          <InputForm
            id="gui_order"
            label="GUI-Reihenfolge"
            type="number"
            register={register}
            errors={errors}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="warning"
            type="submit"
            onClick={handleSubmit(onSubmit)}
          >
            Erstellen
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default TagModal;
